// Generic helper
import * as util from '../view-advice-util'
// Find intersecting keys
import intersection from 'lodash/intersection'
// ----------------------------------------------------------
// Try to find if modifier from this name
// are relevant
// e.g. Unter anderem ist Simvastatin ein Hemmer von IND9X9.
// ----------------------------------------------------------
export default createSection

export function createSection( dict, name1, special ) {

  const inhib = []
  const induc = []
  const paths = []
  var text = ""

  for ( const name2 in special ) {
    // Possible modifications of this drug
    if ( name1 == name2 ) {
      inhib.push( ...Object.keys( special[ name1 ][ "inhibit" ] ) )
      induc.push( ...Object.keys( special[ name1 ][ "induces" ] ) )
    }
    // Collect all possible substrates
    if ( name1 != name2 ) {
      paths.push( ...Object.keys( special[ name2 ][ "pathway" ] ) )
    }
  }

  // Evaluate situation
  const inhibs = intersection( paths, inhib )
  const inducs = intersection( paths, induc )

  // Set empty
  if ( !inhibs.length && !inducs.length ) {
    return text
  }
  // Something needs to be said
  if ( inhibs.length && !inducs.length ) {
    text = dict.bew_mod_inhi
  }
  if ( !inhibs.length && inducs.length ) {
    text = dict.bew_mod_indu
  }
  if ( inhibs.length && inducs.length ) {
    text = dict.bew_mod_both
  }
  // Replace with real cyps and transporters
  if ( inhibs.length ) {
    const last = inhibs.pop()
    const list = inhibs.map( i => `<b class=r>${i}</b>` )
    if ( !list.length ) {
      text = text.replace( "HEM9X9", `<b class=r>${last}</b>` )
    } else {
      text = text.replace( "HEM9X9", `${list.join(", ")} ${dict.bew_mod_et} <b class=r>${last}</b>` )
    }
  }
  if ( inducs.length ) {
    const last = inducs.pop()
    const list = inducs.map( i => `<b class=r>${i}</b>` )
    if ( !list.length ) {
      text = text.replace( "IND9X9", `<b class=r>${last}</b>` )
    } else {
      text = text.replace( "IND9X9", `${list.join(", ")} ${dict.bew_mod_et} <b class=r>${last}</b>` )
    }
  }

  return text

}